import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
import moment from 'moment';

@Component({
  name: 'bpc-datepicker',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class Datepicker extends mixins(AbstractField) {
  @Prop(String) readonly value: string;
  @Prop(Boolean) readonly showArrows: boolean;
  @Prop({ type: Boolean, default: true }) readonly allowDays: boolean;
  @Prop({ type: Boolean, default: true }) readonly allowWeeks: boolean;
  @Prop({ type: Boolean, default: true }) readonly clearable: boolean;
  @Prop({ type: Boolean, default: false }) readonly showDateFrom: boolean;
  @Prop({ type: Boolean, default: false }) readonly showDateTo: boolean;
  @Prop({ type: String }) readonly arrowGroupClass: string;
  @Prop({ type: String, default: 'global.date_range.from.label' }) readonly labelFrom: string;
  @Prop({ type: String, default: 'global.date_range.to.label' }) readonly labelTo: string;
  @Prop({ type: String, default: 'primary' }) readonly variant: string;

  get model(): Date {
    return this.value ? moment(this.value).toDate() : null;
  }

  set model(value) {
    this.$emit('input', value ? moment(value).format('YYYY-MM-DD') : null);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, value);
      });
    }
  }

  get dateLang(): string {
    return this.$i18n.locale === 'be' ? 'fr' : this.$i18n.locale;
  }

  today() {
    const date = moment();
    this.$emit('input', date.format('YYYY-MM-DD'));
  }

  prevDay() {
    const date = moment(this.value);
    date.subtract('1', 'd');
    this.$emit('input', date.format('YYYY-MM-DD'));
  }

  nextDay() {
    const date = moment(this.value);
    date.add('1', 'd');
    this.$emit('input', date.format('YYYY-MM-DD'));
  }

  prevWeek() {
    const date = moment(this.value);
    date.subtract('1', 'w');
    this.$emit('input', date.format('YYYY-MM-DD'));
  }

  nextWeek() {
    const date = moment(this.value);
    date.add('1', 'w');
    this.$emit('input', date.format('YYYY-MM-DD'));
  }
}
